/**
 * @description 对OpenApp的接口做一层抽象
 * @example
 */
define('services/common/ajax/openFeedback',['app','mainCons'], function (app,mainCons) {
    app.factory('OpenFeedBack', ['auiAjaxWithError','$q','auiDialog','$filter',function (auiAjaxWithError,$q,auiDialog,$filter) {
    	
        return {
            getSumByScore:auiAjaxWithError.curryWithoutError('OpenFeedBack','OpenFeedBack.Developer.getSumByScore'),
            submitFeedback:auiAjaxWithError.curryWithoutError('OpenFeedBack','OpenFeedBack.Developer.submitFeedback'),
        }
    }]);
});
